const NumberFormat = ({ value }) => {
    if (value === null || value === undefined) return '';
    return value.toLocaleString('ko-KR');
  };
  
export default NumberFormat;